export enum RolloverAmountCalculationEnum {
  lowerAmount = 'lowerAmount',
  riskAmount = 'riskAmount',
}
